import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import SiteLogo from '../../assets/images/global/seakeeper-logo.png';

var LineChart = require("react-chartjs").Line;
var Auth = new AuthService();

class SingleReport extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		this.chartData = {
		  	labels: ["0°", "", "", "", "", "5°", "", "", "", "", "10°", "", "", "", "", "15°", "", "", "", "", "20°", "", "", "", "", "25°"],
		  	datasets: [
		  		{
		  			label: "Configuration 1",
		  			fillColor: "transparent",
		  			strokeColor: "#01a8e0",
					pointHighlightFill: "#01a8e0",
					borderWidth: 1,
		  			data: [0,0,0,0,0,0]
		  		},
		  		{
		  			label: "Configuration 2",
		  			fillColor: "transparent",
		  			strokeColor: "#9BA5AE",
					pointHighlightFill: "#9BA5AE",
					borderWidth: 4,
		  			data: [0,0,0,0,0,0]
		  		},
				{
		  			label: "Configuration 3",
		  			fillColor: "transparent",
		  			strokeColor: "#031D40",
					pointHighlightFill: "#031D40",
					borderWidth: 4,
		  			data: [0,0,0,0,0,0]
		  		},
				{
		  			label: "Configuration 4",
		  			fillColor: "transparent",
		  			strokeColor: "#A9CEF4",
					pointHighlightFill: "#A9CEF4",
					borderWidth: 4,
		  			data: [0,0,0,0,0,0]
		  		},
				{
		  			label: "Configuration 5",
		  			fillColor: "transparent",
		  			strokeColor: "#5677b6",
					pointHighlightFill: "#5677b6",
					borderWidth: 4,
		  			data: [0,0,0,0,0,0]
		  		}
		  	]
		};

		this.state = {
			report_id: this.props.match.params.report_id,
			chartData: this.chartData,
			chartOptions: {
				pointDot: false,
				bezierCurveTension: 0.3,
				scaleGridLineColor: 'rgba(0,0,0,0.3)'
			},
			displayChart: false,
			lengthUnit: 'Meters',
			weightUnit: 'Kg',
			loading: true,
			userProfile: this.Auth.getProfile()
		}

		this.calculatePlotData = this.calculatePlotData.bind(this);
		this.printReport = this.printReport.bind(this);
		this.isCatamaran = this.isCatamaran.bind(this);
	}

	componentDidMount() {
		const { report_id } = this.state;

		if(report_id) {
			this.Auth.fetch('/prediction/report/' + report_id)
			.then(
				(result) => {
					console.log(result);
					if(result.success) {

						let data = result.data,
							cutoffTime = Date.parse('2023-08-16'),
							newRequirements2023 = false;

						// check approval date
						if (data.approved_date != null && Date.parse(data.approved_date) > cutoffTime) {
							newRequirements2023 = true;
						}

						// convert units for display in both
						data.displacement_english = this.convertKiloToLbs(data.displacement);
						data.loa_english = this.convertMetersToFeet(data.loa);
						data.lwl_english = this.convertMetersToFeet(data.lwl);
						data.boa_english = this.convertMetersToFeet(data.boa);
						data.bwl_english = this.convertMetersToFeet(data.bwl);

						// convert published date
						const monthNames = ["January", "February", "March", "April", "May", "June",
						  "July", "August", "September", "October", "November", "December"
						];

						// parse date for Safari
						let date = data.published_date.split(" ")[0];
						let dateParts = date.split("-");
						let year = dateParts[0];
						let month = dateParts[1];
						let day = dateParts[2];

						const d = new Date(year, month - 1, day);
						console.log(dateParts);
						let publishedMonth = monthNames[d.getMonth()];
						let publishedDay = d.getDate();
						let publishedYear = d.getFullYear();

						data.published_date = publishedMonth + " " + publishedDay + ", " + publishedYear;

                        let sort = true;
                        let configCount = data.configurations.length;
                        let recommendedIndex = 0;

                		while (sort) {
                			sort = false;
                			for(let i=0; i < configCount - 1; i++) {
                				let count = data.configurations[i].ConfigSeakeepers.length,
                					count2 = data.configurations[i+1].ConfigSeakeepers.length,
                					total = data.configurations[i].TotalDeltaPhi,
                					total2 = data.configurations[i+1].TotalDeltaPhi,
                					temp = 0;
								
								for (let a = 0; a < count; a += 1) {
									total += ((data.configurations[i].ConfigSeakeepers[a].angular_momentum * 1) * (data.configurations[i].ConfigSeakeepers[a].sk_model_count * 1));
								}
								for (let a = 0; a < count2; a += 1) {
									total2 += ((data.configurations[i+1].ConfigSeakeepers[a].angular_momentum * 1) * (data.configurations[i+1].ConfigSeakeepers[a].sk_model_count * 1));
								}

                				if (total < total2) {
                					temp = data.configurations[i];
                					data.configurations[i] = data.configurations[i+1];
                					data.configurations[i+1] = temp;
                					sort = true;

                					if(data.configurations[i].recommended === "1" || data.configurations[i].recommended === 1) {
                						recommendedIndex = i;
                					}
                					if(data.configurations[i+1].recommended === "1" || data.configurations[i+1].recommended === 1) {
                						recommendedIndex = i+1;
                					}
                				}
                			}
                		}

						this.setState({
							...this.state,
							...data,
							loading: false,
							newRequirements2023: newRequirements2023,
						}, this.calculatePlotData);
					} else {
						if(result.messages) {
							alert(result.messages.join("\n"));
						}
					}
				},
				(error) => {
					this.setState({
						error
					});
				}
			);
		} else {
			alert("You")
		}
	}

	calculatePlotData() {
		let { configurations, maxReduction, vessel_use } = this.state;

		var configCount = configurations.length;
		var slotCount = 0;
		var pointData = [];
		let userProfile = this.Auth.getProfile();
		let hidden = 0;

		let maxAngle = 25;
		
		// Catamarans only 
		if (this.isCatamaran()) {
			maxAngle = 15;
			this.chartData.labels.splice(-10, 10);

		// all other boat types
		} else {
			if(this.state.vessel_use === "Coastal") {
				maxAngle = 20;
				this.chartData.labels.splice(-5, 5);
			}
		}

		for(let i=0; i<configCount; i++) {
			// don't calculate for dealer if not show

			if(configurations[i].showConfig === "0" || configurations[i].showConfig === 0) {
				hidden++;
				continue;
			}

			pointData = [];
			configurations[i].PlotData = [];
			var point = 0;
			for(let k=0; k<=maxAngle; k+=1) {
				if (k != 0) {
					k = Math.round(k * 100) / 100;
				} else {
					k = 0;
				}
				point = 100 * configurations[i].TotalDeltaPhi / k;
				if(point < maxReduction) {
					configurations[i].PlotData.push({
						degree: k,
						reduction: Math.round(point * 10000) / 10000
					});
					pointData.push(Math.round(point * 10000) / 10000);
				} else {
					configurations[i].PlotData.push({
						degree: k,
						reduction: maxReduction
					});
					pointData.push(maxReduction);
				}
			}
			this.chartData.datasets[i-hidden].data = pointData;
		}

		this.chartData.datasets.splice(configurations.length);
		this.chartData.datasets.push(
			{
				label: "",
				fillColor: "transparent",
				strokeColor: "transparent",
				pointHighlightFill: "transparent",
				data: [90,0]
			}
		)
        console.log(this.chartData, 'chartdata');
		this.setState({
		 	chartData: this.chartData,
			displayChart: true,
			configurations
		});
	}

	convertFeetToMeters(feet) {
		let meters = (feet / 3.2808);
		//meters = Math.round(meters * 100) / 100;
		return meters;
	}

	convertMetersToFeet(meters) {
		let feet = (meters * 3.2808);
		//feet = Math.round(feet * 100) / 100;
		return feet;
	}

	convertKiloToLbs(kilo) {
		let lbs = (kilo * 2.2046);
		//lbs = Math.round(lbs * 100) / 100;
		return lbs;
	}

	convertLbsToKilo(lbs) {
		let kilo = (lbs / 2.2046);
		//kilo = Math.round(kilo * 100) / 100;
		return kilo;
	}

	roundForDisplay(value, decimals) {
			let number = value * 1;
			return number.toFixed(decimals);
	}

	printReport() {
		window.print();
	}

	isCatamaran() {
		return (this.state.boat_sub_application === 10 || this.state.boat_sub_application === 34 || this.state.boat_sub_application === 35);
	}

	render() {

		let configurationList = [];
		let recommendedConfig = {
			ConfigSeakeepers: []
		};
		let recommendedIndex = 1;
		let configCount = (this.state.configurations) ? this.state.configurations.length : 0;
		let title = document.title;
		let skConfigPageTitle = [];

		for(let i=0; i<configCount; i++) {
			if(this.state.configurations[i].showConfig === "1" || this.state.configurations[i].showConfig === 1) {
				configurationList.push(this.state.configurations[i]);
			}
		}

		configCount = configurationList.length;
		for(let i=0; i<configCount; i++) {
			if(configurationList[i].recommended === "1" || configurationList[i].recommended === 1) {
				recommendedConfig = configurationList[i];
				recommendedIndex = i;
				for (let a = 0; a < configurationList[i].ConfigSeakeepers.length; a += 1) {
					skConfigPageTitle.push(configurationList[i].ConfigSeakeepers[a].sk_model_count + 'x' + configurationList[i].ConfigSeakeepers[a].seakeeper_model);
				}
				skConfigPageTitle = skConfigPageTitle.join(' + ');
			}
		}

		let chartData = this.state.chartData;

		if (this.state.loading === false) {
			document.title = 'PP ' + this.state.builder_name + ' ' + this.state.model_name + ' ' + skConfigPageTitle + ' Recommended (' + this.state.published_date + ')';
		}

		// format unit text
		let loaString = this.state.loa;
		let boaString = this.state.boa;
		let lwlString = this.state.lwl;
		let bwlString = this.state.bwl;
		let dispString = this.state.displacement;

		if(this.state.units === "English") {
			loaString = this.roundForDisplay(this.state.loa_english, 2) + " ft / " + this.roundForDisplay(this.state.loa, 2) + " m";
			boaString = this.roundForDisplay(this.state.boa_english, 2) + " ft / " + this.roundForDisplay(this.state.boa, 2) + " m";
			lwlString = this.roundForDisplay(this.state.lwl_english, 2) + " ft / " + this.roundForDisplay(this.state.lwl, 2) + " m";
			bwlString = this.roundForDisplay(this.state.bwl_english, 2) + " ft / " + this.roundForDisplay(this.state.bwl, 2) + " m";
			dispString = this.roundForDisplay(this.state.displacement_english, 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " lbs / " + this.roundForDisplay(this.state.displacement, 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " kg";
		} else {
			loaString = this.roundForDisplay(this.state.loa, 2) + " m / " + this.roundForDisplay(this.state.loa_english, 2) + " ft";
			boaString = this.roundForDisplay(this.state.boa, 2) + " m / " + this.roundForDisplay(this.state.boa_english, 2) + " ft";
			lwlString = this.roundForDisplay(this.state.lwl, 2) + " m / " + this.roundForDisplay(this.state.lwl_english, 2) + " ft";
			bwlString = this.roundForDisplay(this.state.bwl, 2) + " m / " + this.roundForDisplay(this.state.bwl_english, 2) + " ft";
			dispString = this.roundForDisplay(this.state.displacement, 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " kg / " + this.roundForDisplay(this.state.displacement_english, 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " lbs";
		}

		// chart disclaimer
		let disclaimer = '';

		// catamarans only
		if (this.isCatamaran()) {
			if(this.state.vessel_use === "Offshore") {
				disclaimer = (
					<div>
						<div className="pp-disclaimer catamaran-disclaimer">
							<p>Recommended - <br />80% reduction at > +/- 9 degrees</p>
							<p>Minimum - <br />80% reduction at > +/- 6 degrees</p>
							<div className="pp-disclaimer-line pp-catamaran-offshore"></div>
						</div>
					</div>
				);
			} else {
				disclaimer = (
					<div>
						<div className="pp-disclaimer catamaran-disclaimer">
							<p>Recommended - <br />80% reduction at > +/- 6 degrees</p>
							<p>Minimum - <br />80% reduction at > +/- 4 degrees</p>
							<div className="pp-disclaimer-line pp-catamaran-costal"></div>
						</div>
					</div>
				);
			}

		// all other boat types
		} else {
			if(this.state.vessel_use === "Offshore") {
				disclaimer = (
					<div>
						<div className="pp-disclaimer requirements-legacy">
							<p>Recommended - <br />80% reduction at > +/- 15 degrees</p>
							<p>Minimum - <br />80% reduction at > +/- 10 degrees</p>
							<div className="pp-disclaimer-line pp-15-deg-offshore"></div>
						</div>
						<div className="pp-disclaimer requirements-2023">
							<p>Recommended - <br />80% reduction at > +/- 15 degrees</p>
							<p>Minimum - <br />80% reduction at > +/- 11 degrees</p>
							<div className="pp-disclaimer-line pp-15-deg-offshore"></div>
						</div>
					</div>
				);
			} else {
				disclaimer = (
					<div>
						<div className="pp-disclaimer requirements-legacy">
							<p>Recommended - <br />80% reduction at > +/- 10 degrees</p>
							<p>Minimum - <br />80% reduction at > +/- 6 degrees</p>
							<div className="pp-disclaimer-line pp-10-deg-costal"></div>
						</div>
						<div className="pp-disclaimer requirements-2023">
							<p>Recommended - <br />80% reduction at > +/- 11 degrees</p>
							<p>Minimum - <br />80% reduction at > +/- 7 degrees</p>
							<div className="pp-disclaimer-line pp-11-deg-costal"></div>
						</div>
					</div>
				);
			}
		}

		// estimated GMT
		let gmtEst = "";
		if(this.state.gmt === null || (this.state.gmt * 1) === (Math.round(this.state.gmt_est * 100) / 100)) {
			gmtEst = (<p className="pp-disclaimer">* Using an estimate for GMT</p>);
		}

		// estimated Troll
		let troll = this.roundForDisplay(this.state.troll, 2);
		let trollEst = false;
		if(this.state.troll === null || this.state.troll === "0" || this.state.troll === "" || this.state.troll === 0) {
			troll = this.roundForDisplay(this.state.troll_est, 2);
			trollEst = true;
		}

		// boat string
		let boatString = "";
		if(this.state.boat_year && this.state.boat_year !== '0') {
			boatString += this.state.boat_year + " " ;
		}
		if(this.state.builder_name && this.state.model_name) {
			boatString += this.state.builder_name + " - " + this.state.model_name;
		}
		// if(this.state.hull_name && this.state.hull_name !== '') {
		// 	boatString += this.state.hull_name;
		// }

		let province_name = this.state.province_abbreviation || this.state.province_name;

		var header_title = <div>
			<img src={SiteLogo} className="site-logo" />
			<h2 className="pp-heading-2">Performance Prediction Report</h2>
			<p className="pp-heading-3">{this.state.vessel_use} operation</p>
		</div>;

		let newRequirements2023 = this.state.newRequirements2023 === true ? " new-requirements-2023" : ""
		let pageClass = this.state.loading === true ? "pp-single-report-page pp-loading" + newRequirements2023 : "pp-single-report-page" + newRequirements2023;

		// only admin can view sizing form
		let pageActions = <div className="pp-page-actions-wrapper">
			<button className="pp-print-report" onClick={this.printReport}>Print Report</button>
		</div>;
		if(this.state.userProfile.pp_role_id === "1" || this.state.userProfile.pp_role_id === 1) {
			pageActions = <div className="pp-page-actions-wrapper">
				<a href={"/sizing-form/" + this.state.sizing_form_id} className="pp-view-sizing-form">View Sizing Form</a>
				<button className="pp-print-report" onClick={this.printReport}>Print Report</button>
			</div>;
		}


		return (
			<Page
				pageClass={pageClass}
				pageActions={pageActions}
			>
				<PageSection sectionActions={header_title}>
					<div className="pp-boat-title">
						<p className="pp-boat">{boatString}</p>
						<p className="pp-date"><span className="pp-published">Published on</span> {this.state.published_date}</p>
					</div>
					<div className="pp-report-details">
						<div className="pp-boat-details">
							<h4 className="pp-config-title">Vessel Characteristics</h4>
							<dl className="pp-definition-list">
								<dt className="pp-title">Length Overall</dt>
								<dd className="pp-definition">{loaString}</dd>
								<dt className="pp-title">Beam Overall</dt>
								<dd className="pp-definition">{boaString}</dd>
								<dt className="pp-title">{trollEst && 'Est. '}Natural Roll Period</dt>
								<dd className="pp-definition">{troll} sec</dd>
							</dl>
							<dl className="pp-definition-list">
								<dt className="pp-title">Length at Waterline</dt>
								<dd className="pp-definition">{lwlString}</dd>
								<dt className="pp-title">Beam at Waterline</dt>
								<dd className="pp-definition">{bwlString}</dd>
								<dt className="pp-title">Full Load Displacement</dt>
								<dd className="pp-definition">{dispString}</dd>
							</dl>
						</div>
						{gmtEst}
					</div>
					<div className="pp-recommended-configuration">
						<h4 className="pp-config-title">Recommended Seakeeper Configuration</h4>

						<p className={"pp-key-title pp-key-" + (recommendedIndex + 1)}>Configuration {recommendedIndex + 1}</p>
						{this.state.configurations && recommendedConfig.ConfigSeakeepers.map((data, index) => (
							<div className="pp-config-card">
								<h5 className="pp-seakeeper-name"><img src={'https://api.seakeeper.com/' + data.logo_url} className="pp-seakeeper-logo" /></h5>
								<p className="pp-quanity">Qty {data.sk_model_count}</p>
								<img src={'https://api.seakeeper.com/' + data.image_url} className="pp-seakeeper-image" />
								<dl className="pp-definition-list">
									<dt className="pp-title">Weight</dt>
									<dd className="pp-definition">{data.seakeeper_weight} lbs ({Math.round(data.seakeeper_weight / 2.205)}kg)</dd>
									<dt className="pp-title">Dimensions</dt>
									<dd className="pp-definition">{data.length} L x {data.width} W x {data.height} H (inches) <br />{Math.round(data.length * 1000 / 39.37) / 1000} L x {Math.round(data.width * 1000 / 39.37) / 1000} W x{Math.round(data.height * 1000 / 39.37) / 1000} H (meters)</dd>
									<dt className="pp-title">Angular Momentum</dt>
									<dd className="pp-definition">{data.angular_momentum} N-M-S</dd>
								</dl>
							</div>
						))}
					</div>
					<div className="pp-line-chart-section">
						<div className="pp-chart-key">
							<h4 className="pp-config-title">Sizing Key</h4>
							{configurationList && configurationList.map((data, index) => (
								<div className="pp-key-group">
									<p className={"pp-key-title pp-key-" + (index + 1)}>Configuration {index + 1}</p>
									{data.ConfigSeakeepers.map(sk => (
										<dl className="pp-definition-list">
											<dt className="pp-title">{sk.sk_model_count}x</dt>
											<dd className="pp-definition"><img src={'https://api.seakeeper.com/' + sk.logo_url} className={'pp-sk-logo ' + (sk.seakeeper_model).replace(/ /g, "-").replace(/\./g, "-")} /></dd>
										</dl>
									))}
								</div>
							))}

						</div>
						{this.state.displayChart &&
							<div className="pp-line-chart">
								<p className="pp-chart-title">Roll Reduction at Zero Speed in Regular Beam Sea Waves at Natural Roll Period</p>
								<p className="pp-y-title">Percent Uncontrolled Roll Reduction - %</p>
								<p className="pp-x-title">Uncontrolled Roll Amplitude</p>
								{disclaimer}
								<LineChart data={chartData} options={this.state.chartOptions} width="640" height="350"/>
							</div>
						}
					</div>

					<div className="pp-report-disclaimer">
						<p>Objectional boat roll occurs when the wave period matches or is very close to a boat’s natural roll period. This motion is called resonant rolling and a boat will roll at a ratio of 3 to 5 times the slope of the wave in these conditions, which can cause passengers to experience motion sickness, fatigue, and anxiety about the safety of the vessel.</p>
						<p>The Seakeeper configuration is sized for zero speed operation in regular beam seas waves where the wave period is assumed to be equal to the natural roll period of the vessel. This represents a worst-case operating scenario in terms of the rolling motion of the vessel and provides a reference condition for sizing the Seakeeper configuration for various applications.</p>
						<p>The results presented above are in terms of roll reduction percentage with the Seakeeper configuration(s) versus uncontrolled roll amplitude. The uncontrolled roll angle is limited to +/- 20 degrees for coastal applications, or +/- 25 degrees for offshore, as this typically represents the maximum roll angle that a boat will experience.</p>
					</div>

					<div className="pp-consumer-notice">
						<p><strong>NOTICE TO CONSUMER</strong></p>
						<p>Please note that the results contained in this report are Seakeeper's estimate of the performance of the Seakeeper configuration(s) presented for the reference at-rest beam sea condition based on the vessel specifications provided and the tools available to Seakeeper. Performance can vary depending on the accuracy of the methods and variations in actual sea conditions to our assumption of regular beam waves at the vessels natural roll period. Seakeeper assumes that performance underway at low speeds, in beam seas, will be similar to the zero speed reference condition. Due to the random nature of wind generated waves and swell, no guarantee is expressed or implied.</p>
					</div>
				</PageSection>
			</Page>
		);
	}
}

export default SingleReport;



// WEBPACK FOOTER //
// ./src/components/pages/Report.js